'use strict';

var internals = {};
module.exports = {
  settingsCache: Symbol('settingsCache')
};